import { render, staticRenderFns } from "./CustomCampaignCreate.vue?vue&type=template&id=b8d8a730&"
import script from "./CustomCampaignCreate.vue?vue&type=script&lang=js&"
export * from "./CustomCampaignCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports